import { settings } from "imagica-corekit/dist/base/kernel/Settings";
import func from "@uikit/func";
import style from "./PreviewV2ToolBar.module.scss";

const editImg = `${settings.S3CDN}${settings.viewAssetsPath}preview-toolbar-edit.svg`;
const editWhiteImg = `${settings.S3CDN}${settings.viewAssetsPath}preview-toolbar-edit-white-1.svg`;
const editPlaceholderImg = `${settings.S3CDN}${settings.viewAssetsPath}preview-toolbar-edit-placeholder.svg`;
const editPlaceholderWhiteImg = `${settings.S3CDN}${settings.viewAssetsPath}preview-toolbar-edit-placeholder-white-2.svg`;
const deleteImg = `${settings.S3CDN}${settings.viewAssetsPath}preview-toolbar-delete.svg`;
const boldImg = `${settings.S3CDN}${settings.viewAssetsPath}preview-toolbar-bold.svg`;
const boldWhiteImg = `${settings.S3CDN}${settings.viewAssetsPath}preview-toolbar-bold-white.svg`;
const italicImg = `${settings.S3CDN}${settings.viewAssetsPath}preview-toolbar-italic.svg`;
const italicWhiteImg = `${settings.S3CDN}${settings.viewAssetsPath}preview-toolbar-italic-white.svg`;
const underlineImg = `${settings.S3CDN}${settings.viewAssetsPath}preview-toolbar-underline.svg`;
const underlineWhiteImg = `${settings.S3CDN}${settings.viewAssetsPath}preview-toolbar-underline-white.svg`;
const beautifyImg = `${settings.S3CDN}${settings.viewAssetsPath}preview-toolbar-beautify.svg`;
const beautifyWhiteImg = `${settings.S3CDN}${settings.viewAssetsPath}preview-toolbar-beautify-white.svg`;
const captionToggleImg = `${settings.S3CDN}${settings.viewAssetsPath}preview-toolbar-caption-toggle.svg`;
const captionToggleWhiteImg = `${settings.S3CDN}${settings.viewAssetsPath}preview-toolbar-caption-toggle-white.svg`;

// child component
export const EditCp = (props: any) => {
  return (
    <div
      className={`${style["cp-box"]} ${props.highlightBackground ? style["high-light-bar"] : ""}`}
      onClick={props.onClickEdit}
    >
      <img src={props.highlightBackground ? editWhiteImg : editImg} />
    </div>
  );
};
export const EditPlaceHolderCp = (props: any) => {
  return (
    <div
      className={`${style["cp-box"]} ${props.highlightBackground ? style["high-light-bar"] : ""}`}
      onClick={props.onClickEditPlaceholder}
    >
      <img src={props.highlightBackground ? editPlaceholderWhiteImg : editPlaceholderImg} />
    </div>
  );
};
export const BoldCp = (props: any) => {
  const isBold = props.currentOutput.results?.[0]?.isBold;
  return (
    <div
      className={`${style["cp-box"]} ${isBold ? style["high-light-bar"] : ""}`}
      onClick={() => props.clickOutputCssStyleCp("isBold")}
    >
      <img src={isBold ? boldWhiteImg : boldImg} />
    </div>
  );
};
export const ItalicCp = (props: any) => {
  const isItalic = props.currentOutput.results?.[0]?.isItalic;
  return (
    <div
      className={`${style["cp-box"]} ${isItalic ? style["high-light-bar"] : ""}`}
      onClick={() => props.clickOutputCssStyleCp("isItalic")}
    >
      <img src={isItalic ? italicWhiteImg : italicImg} />
    </div>
  );
};
export const UnderLineCp = (props: any) => {
  const isUnderLine = props.currentOutput.results?.[0]?.isUnderLine;
  return (
    <div
      className={`${style["cp-box"]} ${isUnderLine ? style["high-light-bar"] : ""}`}
      onClick={() => props.clickOutputCssStyleCp("isUnderLine")}
    >
      <img src={isUnderLine ? underlineWhiteImg : underlineImg} />
    </div>
  );
};
export const BeautifyCp = (props: any) => {
  const isBeautify = props.currentOutput.results?.[0]?.isBeautify;
  return (
    <div
      className={`${style["cp-box"]} ${isBeautify ? style["high-light-bar"] : ""}`}
      onClick={() => props.clickOutputCssStyleCp("isBeautify")}
    >
      <img src={isBeautify ? beautifyWhiteImg : beautifyImg} />
    </div>
  );
};
export const CaptionToggleCp = (props: any) => {
  const isCaptionToggle = !func.isEmpty(props.currentOutput.results?.[0]?.isCaptionToggle);
  const hasContext = !func.isEmpty(props.currentOutput.results?.[0]?.content?.context);
  const isDisabled = !hasContext;
  const classArr = [
    `${style["cp-box"]}`,
    `${isCaptionToggle ? style["high-light-bar"] : ""}`,
    `${isDisabled ? style["disabled-bar"] : ""}`,
  ];

  const onClick = () => {
    if (isDisabled) return;
    props.clickOutputStateCp("isCaptionToggle");
  };

  return (
    <div className={classArr.join(" ")} onClick={onClick}>
      <img src={isCaptionToggle ? captionToggleWhiteImg : captionToggleImg} />
    </div>
  );
};
export const DeleteCp = (props: any) => {
  return (
    <div className={style["cp-box"]} onClick={props.onClickRemove}>
      <img src={deleteImg} />
    </div>
  );
};
